export default __webpack_public_path__ + "static/media/home.a1e8a256.svg";